import { CoursePackage } from '@/jbi-shared/dto/jtms-public-course.dtos';
import { RootState } from '@/store/store';
import { DispatchOptions } from 'vuex';
import {
  PackageSelection,
  ShortCourseCheckoutState
} from './short-course-checkout.types';

interface ShortCourseCheckoutActionContext {
  commit: (mutation: string, payload?: any) => void;
  dispatch: (
    action: string,
    payload?: any,
    options?: DispatchOptions
  ) => Promise<any>;
  state: ShortCourseCheckoutState;
  rootState: RootState;
}

export const shortCourseCheckoutActions = {
  assignPackageSelectionsFromCoursePackages(
    { commit }: ShortCourseCheckoutActionContext,
    payload: CoursePackage[]
  ) {
    commit('ASSIGN_PACKAGE_SELECTIONS_FROM_COURSE_PACKAGES', payload);
  },

  updatePackageSelections(
    { commit }: ShortCourseCheckoutActionContext,
    payload: PackageSelection[]
  ) {
    commit('UPDATE_PACKAGE_SELECTIONS', payload);
  },

  setIsLastStep(
    { commit }: ShortCourseCheckoutActionContext,
    isLastStep: boolean
  ) {
    commit('SET_IS_LAST_STEP', isLastStep);
  }
};
